import StateInterface from "../state-interface";

export const ner_search_states: StateInterface["ner_search_states"] = {
	search_term: "",
	last_searched_term: "",
};
